<template>
  <el-card class="route">
    <div slot="header" class="clearfix">
      <span class="text">{{route.name}}</span>
         
      <el-dropdown hide-on-click trigger="click" @command="handleCommand" class="pointNumber">
        <span class="el-dropdown-link">
          <em class="el-icon-arrow-down el-icon--right"></em>
        </span>
        <el-dropdown-menu v-if="checkPermission('updateRoute') || checkPermission('deleteRoute')" slot="dropdown" >
          <el-dropdown-item v-if="checkPermission('updateRoute')" command="edit">{{$t('common.edit')}}</el-dropdown-item>
          <el-dropdown-item v-if="checkPermission('deleteRoute')" divided command="delete">{{$t('common.delete')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <em style="float:right; font-size:13px; margin-right:10px; line-height:20px; color:#121212"> {{pointCount}} {{$t('routes.points')}}</em>
    </div>
    <div v-if="!editing">
      <el-tree
        ref="tree"
        :data="routeTree"
        node-key="_id"
        :props="options"
        :show-checkbox="options.checkbox"
      >
        <span class="custom-tree-node" slot-scope="{ node }">
          <span>
            <span v-if="node.data.nodeType =='point'">
              <em class="fas fa-crosshairs"></em>
              {{node.data.name}}
            </span>
            <span v-if="node.data.nodeType =='group'">{{node.data.name}}</span>
          </span>
        </span>
      </el-tree>
      <br />
      <!-- <el-button style="float:right" type="danger" @click="remove()">$t('common.delete')</el-button> -->
    </div>
    <RouteEdit v-if="editing" :route="route" @updated="editing=false" @cancelled="editing=false" />
  </el-card>

</template>

<script>
import RouteEdit from "./Route_Edit";
import util from "../util";
import { mapActions } from "vuex";

export default {
  name: "CreateRoute",
  events: ["created"],
  components: { RouteEdit },
  props: ["route"],
  data() {
    return {
      editing: false,
      options: {
        label: "name",
        children: "children",
        checkbox: false
      }
    };
  },
  created() {},
  mounted() {},
  computed: {
    pointCount (){
      return this.route.tree.filter(x=>x.nodeType=='point').length
    },
    routeTree() {
      let data = this.route.tree.map(x => {
        return {
          ...x,
          parent: x.parent || x.tagGroup // ninja
        };
      });
      return util.parseTree(data);
    }
  },
  methods: {
    ...mapActions("route", ["deleteRoute"]),
    edit() {
      this.editing = true;
    },
    remove(){
      this.$confirm(this.$t('common.AreYouSure'), this.$t('common.warning'), {
        confirmButtonText: this.$t('common.warningConfirmText'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      })
        .then(() => this.deleteRoute(this.route._id))
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t('common.DeleteCompleted')
          });
        });
    },
    handleCommand(command){
      switch(command){
        case 'edit': this.edit(); break
        case 'delete': this.remove(); break
      }
    }
  }
};
</script>

<style scoped>
.route {
  width: 300px;
  margin:   10px;
}
.text {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; 
}
 .pointNumber{ 
  margin-top:5px;
  float: right;
  padding: 3px 0;
} 
</style>